export default {
  name: "QuestionSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M16 2a14 14 0 1 0 0 28 14 14 0 0 0 0-28zm0 22a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm2.96-7.91c-.87.61-1.33.96-1.49 1.72A1.5 1.5 0 0 1 16 19a1.5 1.5 0 0 1-1.47-1.81c.41-1.95 1.74-2.88 2.71-3.56 1.01-.7 1.26-.95 1.26-1.63 0-.35-.18-1.5-2.5-1.5-1.31 0-1.87.59-2.29 1.49a1.5 1.5 0 0 1-2 .7 1.5 1.5 0 0 1-.71-2 5.18 5.18 0 0 1 5-3.19c3.78 0 5.5 2.33 5.5 4.5 0 2.31-1.47 3.34-2.54 4.09z",
  },
}
